import { SUPPORT, ADMIN, LOGISTIC } from '@/middlewares/permissions';

export default {
	userTypes: {
		agent: ADMIN,
		restaurant: SUPPORT,
		courier: LOGISTIC,
		names: {
			[ADMIN]: 'Admin',
			[SUPPORT]: 'Restaurant',
			[LOGISTIC]: 'Driver',
		},
	},
	templateColumns: [
		{ key: 'description', keyProp: 'description', label: 'User Template', isSortable: true },
		{ key: 'cDate', keyProp: 'cDate', label: 'Created Date', isSortable: true },
		{ key: 'mDate', keyProp: 'mDate', label: 'Modified Date', isSortable: true },
		{ key: 'usersNo', keyProp: 'usersNo', label: 'Tot Users', isSortable: true },
		{ key: 'status', keyProp: 'status', label: 'Status', isSortable: true },
	],
	columns: [
		{ key: 'name', label: 'Name', isSortable: true },
		{ key: 'registrationtime', label: 'Registration Time', isSortable: true },
		{ key: 'city', label: 'City' },
		{ key: 'department', label: 'Department' },
		{ key: 'position', label: 'Position' },
		{ key: 'phone', label: 'Phone', class: 'w-16' },
		{ key: 'email', label: 'Email', class: 'w-16' },
		{ key: 'status', label: 'Status', class: 'w-16' },
	],
	extraColumnsPerType: {
		[LOGISTIC]: [
			{ key: 'maxOrdersAllowed', label: 'Max orders' },
			{ key: 'avgRate', label: 'Rating' },
		],
	},
	userStatus: [
		{ key: 'userType', label: 'All', value: -1 },
		{ key: 'userType', label: 'Admin', value: ADMIN },
		{ key: 'userType', label: 'Restaurant', value: SUPPORT },
		{ key: 'userType', label: 'Driver', value: LOGISTIC },
	],
	defaultFilters: {
		limit: 50,
		offset: 0,
		userType: -1,
		positionId: -1,
		status: 1,
		nameFilter: null,
		emailFilter: null,
	},
	statuses: [
		{ label: 'All', value: -1 },
		{ label: 'Active', value: 1 },
		{ label: 'Inactive', value: 0 },
	],
};
